import moment from 'moment'

export const cameraHistoryColumns = [
  {
    id: 'updatedAt',
    name: 'Atualização',
  },
  {
    id: 'lastUpdate',
    name: 'Atualizado há',
  },
  {
    id: 'user',
    name: 'Nome do usuário',
  },
  {
    id: 'before',
    name: 'Antes da alteração',
  },
  {
    id: 'after',
    name: 'Depois da alteração',
  },
]

export function cameraFormatRows(cameraHistorics: ConfigHistoryJson[]) {
  return cameraHistorics.map((cameraHistoric) => {
    const newDate = moment(cameraHistoric.updatedAt).format('DD/MM/YYYY HH:mm:ss')
    const lastUpdate = moment(cameraHistoric.updatedAt).fromNow()
    const newUpdate = lastUpdate.split(' ').slice(1).join(' ')

    return {
      ...cameraHistoric,
      updatedAt: newDate.toLocaleString(),
      lastUpdate: newUpdate,
    }
  })
}

export function diffJson(beforeChange: Record<string, any>, afterChange: Record<string, any>) {
  const modified = {}
  const previous = {}

  function compareObjects(before: Record<string, any>, after: Record<string, any>, path = '') {
    for (const key in after) {
      const fullPath = path ? `${path}.${key}` : key

      if (typeof after[key] === 'object' && after[key] !== null && !Array.isArray(after[key])) {
        compareObjects(before?.[key] || {}, after[key], fullPath)
      } else if (after[key] !== before?.[key]) {
        setNestedValue(modified, fullPath, after[key])
        setNestedValue(previous, fullPath, before?.[key])
      }
    }
  }

  function setNestedValue(obj: Record<string, any>, path: string, value: string) {
    const keys = path.split('.')
    let current = obj
    keys.forEach((k, i) => {
      if (i === keys.length - 1) {
        current[k] = value
      } else {
        current[k] = current[k] || {}
        current = current[k]
      }
    })
  }

  compareObjects(beforeChange, afterChange)

  return {modified, previous}
}

export type ConfigHistoryJson = {
  id: number
  userName: string
  updatedAt: Date
  beforeChange: string
  afterChange: string
}
